import { render } from "./SceneView.vue?vue&type=template&id=506b917e"
import script from "./SceneView.vue?vue&type=script&lang=js"
export * from "./SceneView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apiffare/projects/norbert-weston/norbert-weston-1/apps/norbert-weston-flirter/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__